<template>
    <div>
        <v-card flat>
            <v-card-text>
 <v-layout wrap justify-center align-center >
     <v-flex xs6 sm4 lg2 v-for="operator in networkOperators" :key="operator.id">
<v-card hover style="border: 1px solid grey; borderRadius: 20px" @click="selectOperator(operator)">
            <v-card-text>
                <v-img :src="operator.organisation.logo"></v-img>
                <h3>{{operator.organisation.name}}</h3>
            </v-card-text>
        </v-card>
     </v-flex>
             
        </v-layout>
            </v-card-text>
        </v-card>
       
       
    </div>
</template>
<script>
import Api from "@/services/Api.js";
export default {
    data(){
        return {
networkOperators: []
        }
    },
    created(){
this.getNetworkOperators()
    },
    methods: {
        getNetworkOperators() {
      Api()
        .get("/networkOperators")
        .then((response) => {
          this.networkOperators = response.data;
        });
    },
    selectOperator(operator){
        this.$emit('selectOperator', operator.organisation)
    }
    }
}
</script>